<div class="consortium-form">
  <form [formGroup]="consortiumForm">
    <mat-card>
      <mat-card-content class="form-header-row">
        <mat-form-field appearance="fill">
          <mat-label>Consortium Name</mat-label>
          <input matInput formControlName="name" placeholder="Consortium Name" autocomplete="off" required>
          @if (name.invalid && name.touched && name.hasError('required')) {
            <mat-error>Consortium Name is Required</mat-error>
          }
          @if (name.hasError('trimError')) {
            <mat-error>Remove Blank spaces from start and end</mat-error>
          }
        </mat-form-field>
        <div class="status-toggle-bar">
          <mat-hint class="status-hint">{{showStatus}} </mat-hint>
          @if (showDeactivateToggle && id.value) {
            <mat-slide-toggle (change)="openDeactivateForm($event)" [(ngModel)]="checked"
              [ngModelOptions]="{standalone: true}">Deactivate Consortium</mat-slide-toggle>
          }
          @if (showReactivateToggle && id.value) {
            <mat-slide-toggle (change)="openReactivateForm($event)" [(ngModel)]="checked"
              [ngModelOptions]="{standalone: true}">Reactivate Consortium</mat-slide-toggle>
          }
        </div>
      </mat-card-content>
      <mat-divider></mat-divider>
      <mat-card-content class="card-margin">
        <h4 class="section-title">Line / NVOCC Details</h4>
        <div class="line-container">
          <table class="table table-border gsa-table line-table">
            <thead class="text-nowrap">
              <tr>
                <th>Line (code)</th>
                <th>Line Name</th>
                <th>Deactivate</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              @for (item of lineDetails.controls; track item; let i = $index) {
                <ng-container formArrayName="lineDetails">
                  <tr [formGroupName]="i">
                    <td>
                      <mat-form-field appearance="fill">
                        <mat-select (selectionChange)="lineChanged(i,$event.value)" formControlName="lineId" placeholder="Select Line" required>
                          <mat-option>
                            <ngx-mat-select-search  [searching]="searching" [formControl]="lineSearchCtrl"
                              noEntriesFoundLabel="'no matching found'" placeholderLabel="Find Line">
                              <mat-icon ngxMatSelectSearchClear>delete</mat-icon>
                            </ngx-mat-select-search>
                          </mat-option>
                          <mat-option [value]="null">None</mat-option>
                          @for (item of filteredLines |async; track item) {
                            <mat-option [disabled]="item.status=='DEACTIVATED'" [value]="item.id">
                              {{item.name}}-({{item.code}})
                            </mat-option>
                          }
                        </mat-select>
                        @if (lineDetails.controls[i].get('lineId').errors?.required) {
                          <mat-error class="mt-1">
                            Required
                          </mat-error>
                        }
                      </mat-form-field>
                    </td>
                    <td>
                      <mat-form-field appearance="fill">
                        <input matInput formControlName="lineName" placeholder="Line Name" autocomplete="off" readonly>
                      </mat-form-field>
                    </td>
                    <td>
                      <mat-checkbox class="table-checkbox" formControlName="deactivated"></mat-checkbox>
                    </td>
                    <td class="__action_row">
                      @if (removeLineCondition(i)) {
                        <span class="__action_delete_icon table-action-icon" (click)="removeLineField(i)">
                          <mat-icon>delete</mat-icon>
                        </span>
                      }
                      <span class="__action_edit_icon table-action-icon" (click)="addLineField(item)">
                        <mat-icon>add</mat-icon>
                      </span>
                    </td>
                  </tr>
                </ng-container>
              }
            </tbody>
          </table>
        </div>
      </mat-card-content>
      <mat-divider></mat-divider>
      <mat-card-content class="card-margin">
        <h4 class="section-title">Vessel Details</h4>
        <div class="line-container">
          <table class="table table-border vessel-table">
            <thead>
              <tr>
                <th>Vessel Name</th>
                <th>Deactivate</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              @for (item of vesselDetails.controls; track item; let i = $index) {
                <ng-container formArrayName="vesselDetails">
                  <tr [formGroupName]="i">
                    <td>
                      <mat-form-field appearance="fill">
                        <mat-select (selectionChange)="vesselChanged(i,$event.value)" formControlName="vesselId" placeholder="Select Vessel" required>
                          <mat-option>
                            <ngx-mat-select-search  [searching]="searching"
                              noEntriesFoundLabel="'no matching found'" placeholderLabel="Find Vessel" [formControl]="vesselSearchCtrl">
                              <mat-icon ngxMatSelectSearchClear>delete</mat-icon>
                            </ngx-mat-select-search>
                          </mat-option>
                          <mat-option [value]="null">None</mat-option>
                          @for (item of filteredVessel | async; track item) {
                            <mat-option [value]="item.name?item.id:null">
                              {{item.name}}
                            </mat-option>
                          }
                        </mat-select>
                        @if (vesselDetails.controls[i].get('vesselId').errors?.required) {
                          <mat-error>
                            Required
                          </mat-error>
                        }
                      </mat-form-field>
                    </td>
                    <td>
                      <mat-checkbox class="table-checkbox" formControlName="deactivated"></mat-checkbox>
                    </td>
                    <td class="__action_row">
                      @if (removeVesselCondition(i)) {
                        <span class="__action_delete_icon table-action-icon" (click)="removeVesselField(i)">
                          <mat-icon>delete</mat-icon>
                        </span>
                      }
                      <span class="__action_edit_icon table-action-icon" (click)="addVesselField(item)">
                        <mat-icon>add</mat-icon>
                      </span>
                    </td>
                  </tr>
                </ng-container>
              }
            </tbody>
          </table>
        </div>
      </mat-card-content>
      <mat-divider></mat-divider>
      <mat-card-content class="card-margin">
        <div class="detail-header">
          <h4 class="section-title">Destination Details</h4>
          @if (!consortiumForm.disabled) {
            <button mat-button color="primary" type="button" (click)="addDestinationField()" matTooltip="Add Destination">
              <mat-icon>add_circle</mat-icon> Add Destination
            </button>
          }
        </div>
        <div class="line-container">
          <table class="table table-border destination-table">
            <thead class="text-nowrap">
              <tr>
                <th>Destination (code)</th>
                <th>Destination Name</th>
                <th>Deactivate</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              @for (item of destinationDetails.controls; track item; let i = $index) {
                <ng-container formArrayName="destinationDetails">
                  <tr [formGroupName]="i">
                    <td>
                      <mat-form-field appearance="fill">
                        <mat-select (selectionChange)="destinationChanged(i,$event.value)" formControlName="destinationId" placeholder="Select Destination" required>
                          <mat-option>
                            <ngx-mat-select-search formControlName="destinationSearch" placeholderLabel="Search Destination"
                              noEntriesFoundLabel="No item found" ></ngx-mat-select-search>
                          </mat-option>
                          <mat-option [value]="null">None</mat-option>
                          @for (d of item.get('destinationList').value; track d) {
                            <mat-option [disabled]="checkDestinationOptionDisable(d,item)" [value]="d.id" >
                              {{ d.name }} ({{d.code}})
                            </mat-option>
                          }
                        </mat-select>
                        @if (destinationDetails.controls[i].get('destinationId').errors?.required) {
                          <mat-error>
                            Required
                          </mat-error>
                        }
                      </mat-form-field>
                    </td>
                    <td>
                      <mat-form-field appearance="fill">
                        <input matInput formControlName="destinationName" placeholder="Destination Name" autocomplete="off" readonly>
                      </mat-form-field>
                    </td>
                    <td>
                      <mat-checkbox (change)="destinationDeactivateChanged(i,item)" class="table-checkbox" formControlName="deactivated"></mat-checkbox>
                    </td>
                    <td class="__action_row">
                      @if (getRemoveDestinationCond(i)) {
                        <span class="__action_delete_icon table-action-icon" (click)="removeDestinationField(i)">
                          <mat-icon>delete</mat-icon>
                        </span>
                      }
                    </td>
                  </tr>
                </ng-container>
              }
            </tbody>
          </table>
        </div>
      </mat-card-content>
      <mat-divider></mat-divider>
      <mat-card-content class="card-margin " >
        <div class="detail-header">
          <h4 class="section-title">Consortium Services</h4>
          @if (!consortiumForm.disabled) {
            <button mat-button color="primary" type="button" (click)="addServiceField()" matTooltip="Add Consortium Service">
              <mat-icon>add_circle</mat-icon> Add Consortium Service
            </button>
          }
        </div>
        <div class="service-container">
          <table class="table table-border">
            <thead>
              <tr>
                <th>Code</th>
                <th>Port</th>
                <th>Destination</th>
                <th>Mode</th>
                <th>Transit Time</th>
                <th>Arrival Day POL</th>
                <th>Departure Day POL</th>
                <th>Arrival Day Destination</th>
                <th>Deactivate</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              @for (item of consortiumServiceDetails.controls; track item; let i = $index) {
                <ng-container formArrayName="consortiumServiceDetails">
                  <tr [formGroupName]="i">
                    <td>
                      <mat-form-field appearance="fill">
                        <input matInput formControlName="code" placeholder="Code" autocomplete="off" readonly>
                      </mat-form-field>
                    </td>
                    <td>
                      <mat-form-field appearance="fill">
                        <mat-select (selectionChange)="servicePortChanged(item,i)" formControlName="portId" placeholder="Select Port" required>
                          <mat-option>
                            <ngx-mat-select-search formControlName="portSearch" placeholderLabel="Search Port"
                              noEntriesFoundLabel="No item found" ></ngx-mat-select-search>
                          </mat-option>
                          <mat-option [value]="null">None</mat-option>
                          @for (p of item.get('portList').value; track p) {
                            <mat-option [disabled]="checkPortDisableCondition(p,item)" [value]="p.id" >
                              {{ p.name }} ({{p.code}})
                            </mat-option>
                          }
                        </mat-select>
                        @if (consortiumServiceDetails.controls[i].get('portId').errors?.required) {
                          <mat-error>
                            Required
                          </mat-error>
                        }
                      </mat-form-field>
                    </td>
                    <td>
                      <mat-form-field appearance="fill">
                        <mat-select (selectionChange)="serviceDestinationChanged(item,i)" formControlName="destinationId" placeholder="Select Destination" required>
                          <mat-option>
                            <ngx-mat-select-search formControlName="destinationSearch" placeholderLabel="Search Destination"
                              noEntriesFoundLabel="No item found" ></ngx-mat-select-search>
                          </mat-option>
                          <mat-option [value]="null">None</mat-option>
                          @for (d of item.get('destinationList').value; track d) {
                            <mat-option [disabled]="checkDestinationDisableCondition(d,item)" [value]="d.id" >
                              {{ d.name }} ({{d.code}})
                            </mat-option>
                          }
                        </mat-select>
                        @if (consortiumServiceDetails.controls[i].get('destinationId').errors?.required) {
                          <mat-error>
                            Required
                          </mat-error>
                        }
                      </mat-form-field>
                    </td>
                    <td>
                      <mat-form-field appearance="fill">
                        <mat-select formControlName="mode" placeholder="Mode" required>
                          <mat-option [value]="null">None</mat-option>
                          @for (mode of modes; track mode) {
                            <mat-option [value]="mode">
                              {{mode}}
                            </mat-option>
                          }
                        </mat-select>
                        @if (consortiumServiceDetails.controls[i].get('mode').errors?.required) {
                          <mat-error>
                            Required
                          </mat-error>
                        }
                      </mat-form-field>
                    </td>
                    <td>
                      <mat-form-field appearance="fill">
                        <input matInput type="number" min="1" formControlName="transitTime" autocomplete="off" required>
                        @if (consortiumServiceDetails.controls[i].get('transitTime').errors?.required) {
                          <mat-error>
                            Required
                          </mat-error>
                        }
                        @if (consortiumServiceDetails.controls[i].get('transitTime').errors?.pattern) {
                          <mat-error>
                            Enter Valid Time
                          </mat-error>
                        }
                      </mat-form-field>
                    </td>
                    <td>
                      <mat-form-field appearance="fill">
                        <mat-select formControlName="arrivalDayPol" placeholder="Select Arrival Day POL" required>
                          <mat-option [value]="null">None</mat-option>
                          @for (item of portOfLoadings; track item) {
                            <mat-option [value]="item.key">
                              {{item.label}}
                            </mat-option>
                          }
                        </mat-select>
                        @if (consortiumServiceDetails.controls[i].get('arrivalDayPol').errors?.required) {
                          <mat-error>
                            Required
                          </mat-error>
                        }
                      </mat-form-field>
                    </td>
                    <td>
                      <mat-form-field appearance="fill">
                        <mat-select formControlName="departureDayPol" placeholder="Select Departure Day POL" required>
                          <mat-option [value]="null">None</mat-option>
                          @for (item of portOfLoadings; track item) {
                            <mat-option [value]="item.key">
                              {{item.label}}
                            </mat-option>
                          }
                        </mat-select>
                        @if (consortiumServiceDetails.controls[i].get('departureDayPol').errors?.required) {
                          <mat-error>
                            Required
                          </mat-error>
                        }
                      </mat-form-field>
                    </td>
                    <td>
                      <mat-form-field appearance="fill">
                        <mat-select formControlName="arrivalDayDestination" placeholder="Select Arrival Day Destination" required>
                          <mat-option [value]="null">None</mat-option>
                          @for (item of portOfLoadings; track item) {
                            <mat-option [value]="item.key">
                              {{item.label}}
                            </mat-option>
                          }
                        </mat-select>
                        @if (consortiumServiceDetails.controls[i].get('arrivalDayDestination').errors?.required) {
                          <mat-error>
                            Required
                          </mat-error>
                        }
                      </mat-form-field>
                    </td>
                    <td>
                      <mat-checkbox class="service-cell-offset" formControlName="deactivated"></mat-checkbox>
                    </td>
                    <td class="service-cell-offset">
                      @if (removeServiceCondition(i)) {
                        <span class="__action_delete_icon table-action-icon" (click)="removeServiceField(i)">
                          <mat-icon>delete</mat-icon>
                        </span>
                      }
                    </td>
                  </tr>
                </ng-container>
              }
            </tbody>
          </table>
        </div>
      </mat-card-content>
      <mat-card-actions>
        @if (getSaveBtnCondition()) {
          <button mat-button color="primary" class="form-action-btn" (click)="onSave()">Save</button>
        }
        <button mat-button color="cancel" class="form-action-btn" (click)="onCancel()">Cancel</button>
      </mat-card-actions>
      <mat-card-content>
        @if (id.value) {
          <div class="audit-log">
            <button mat-stroked-button type="button" [class.active]="viewLog.value"
                (click)="viewLog.setValue(!viewLog.value)">
                <mat-icon>history</mat-icon> View Log
            </button>
          </div>
        }
        @if (viewLog.value) {
          <app-history [referenceType]="'CONSORTIUM'" [referenceId]="id.value"></app-history>
        }
      </mat-card-content>
    </mat-card>
  </form>
</div>
